import { Network } from '../../../../utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getProducts(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest(data) {
  // const storeId = await self.servicesVars.getStoreId()
  let url = `${urls.getProducts}`
  if (data.dailyDeals) url = urls.getDailyDeals
  if (data.storeId) url += data.storeId
  if (data.search) url = `${urls.searchProducts}${data.search}`

  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    let rawData = response.response.data?.results || response.response.data
    const appData = Formatter.parseExternalProducts(rawData)

    return {
      success: true,
      statusCode: 200,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalProducts([])

    return {
      success: true,
      statusCode: 200,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getProducts }
